import axios from 'axios';

export default class KeyGenActions {
  constructor(resource, publicUrl, customConfig) {
    this.publicUrl = publicUrl;
    this.resource = resource;
    this.customConfig = customConfig;
  }

  getOrganisationName(code) {
    return axios.get(
      `${this.publicUrl}${this.resource}/${code}/name`,
      this.customConfig
    );
  }
}
